export * from './shape-styles.type';
